/**
 * --------------------------------------------------
 * Cards list filtering Module
 *
 * @module CardList
 * --------------------------------------------------
 */

export default {
    _$grid: null,
    _$paginationElem: null,
    _$cardTemplate: null,
    _$loadmoreBtn: null,
    _$filterItem: null,
    _$filterElem: null,
    _$searchInput: null,

    // Variables for pagination and data
    _dataSection: null,
    _currentPage: null,
    _totalPages: null,
    _currentPost: null,
    _totalItems: null,
    _activeFilters: [],

    // Initialize the CardList module
    setup: function () {
        // Set element selectors
        this._$grid = $('.rt-js-grid');
        this._$cardTemplate = this._$grid.find('.rt-js-card').first();
        this._$paginationElem = $('.rt-js-pagination');
        this._$loadmoreBtn = this._$paginationElem.find('.rt-js-loadmore');
        this._$filterItem = $('.rt-js-filter-item');
        this._$filterElem = $('.rt-js-filter');
        // rt-js-search-blk-input is reserved for in-block/template search inputs only (not the header search)
        this._$searchInput = $('.rt-js-search-blk-input');

        // Pagination variables
        this._dataSection = this._$grid.data('section');
        this._currentPage = this._$grid.data('current-page');
        this._totalPages = this._$grid.data('total-pages');
        this._currentPost = this._$grid.data('current-post');
        this._totalItems = this._$grid.data('total-items');

        // Add event listeners
        this.listeners();

        // Create preloader element
        this._createPreloader();
    },

    // Add event listeners for pagination buttons and filters
    listeners: function () {
        const _self = this;

        // Load more button
        this._$loadmoreBtn.on('click', e => {
            e.preventDefault();
            // Load the data
            _self.onLoadMore();
        });

        // Show/hide filter dropdown
        this._$filterElem.on('click', function (e) {
            _self._showHideMenu(e.currentTarget, 'show');
        });

        // Search input — debounced, triggers same flow as filters
        if (this._$searchInput.length) {
            let searchTimer;
            this._$searchInput.on('input', function (e) {
                clearTimeout(searchTimer);
                searchTimer = setTimeout(() => {
                    _self.onSearch($(e.currentTarget).val().trim());
                }, 400);
            });
        }

        // Filter items
        this._$filterItem.on('click', function (e) {

            const $elemLink = $(e.currentTarget).attr('href');

            // Check if link is not # to let it pass though
            if ($elemLink !== '#') return;

            // Prevent default action
            e.preventDefault();
            e.stopPropagation();

            // Set the filter
            _self.onFilter(e.currentTarget);
            
            // Hide the menu after selection
            _self._showHideMenu(e.currentTarget, 'hide');
        });
    },

    // Function to display cards
    displayCards: function (data) {
        // function variables
        const _self = this;
        const totalCards = Object.keys(data).length;
        const isHiddenClass = 'is-hidden';
        const $cardTemplate = _self._$cardTemplate && _self._$cardTemplate.length ? _self._$cardTemplate[0] : null;

        if (!$cardTemplate) {
            this._showPreloader('hide');
            return;
        }

        // Remove preloader if present
        this._showPreloader('hide');

        // Show no results message if no cards
        if (totalCards === 0) {
            const heading = $('meta[name="no-results-heading"]').attr('content') || 'No results found.';
            const text    = $('meta[name="no-results-text"]').attr('content')    || 'Please adjust your filters.';
            this._$grid.append('<p class="rt-no-results rt-js-no-results"><strong>' + heading + '</strong><br>' + text + '</p>');
            this._$paginationElem.hide();
            return;
        } else {
            this._$grid.find('.rt-js-no-results').remove();
            this._$paginationElem.show();
        }

        // Loop through the data and create cards
        for (let i = 0; i < totalCards; i++) {
            let $newCard = $($cardTemplate).clone();
            let cardId = "card-" + data[i].id;
            $newCard.addClass('rt-card--hidden').attr('id', cardId);
            _self._$grid.append($newCard[0]);
            _self._feedCard($newCard, data[i]);
            // Animate card appearance
            setTimeout(() => {
                $newCard.removeClass('rt-card--hidden');
            }, (i + 1) * 50);
        }

        // Hide load more button if on last page
        if (_self._currentPage === _self._totalPages) {
            _self._$loadmoreBtn.addClass(isHiddenClass);
        } else {
            _self._$loadmoreBtn.removeClass(isHiddenClass);
        }

        // Update the counter
        this._updateCounter();
    },

    // Function to load more data (pagination)
    onLoadMore: function () {
        this._currentPage++;
        this._$grid.attr('data-current-page', this._currentPage);

        this.loadCards(data => {
            this._cleanResponseObject(data);
            this.displayCards(data);
        });
    },

    // Function to handle search input
    onSearch: function (value) {
        // Update or remove the search entry in active filters
        this._activeFilters = this._activeFilters.filter(f => f[0] !== 'search');
        if (value) this._activeFilters.push(['search', value]);
        this._currentPage = 1;

        // Hide cards, then load new cards after animation
        this._hideCards(() => {
            this._showPreloader('show');
            this.loadCards(data => {
                this._$grid.empty();
                this._cleanResponseObject(data);
                this.displayCards(data);
            });
        });
    },

    // Function to filter the cards
    onFilter: function (e) {
        // Set some variables and extract data attributes
        const filter = $(e).data('filter');
        const value = $(e).data('value');
        const label = $(e).attr('label');
        const $filterLabel = $(e).closest('.rt-js-filter').find('.rt-js-filter-label');
        const trimmedLabel = label.trim();
        const $activeElem = $(e).parent();
        const activeClass = 'is-active';

        // Set label and active class
        $activeElem.addClass(activeClass).siblings().removeClass(activeClass);
        $filterLabel.text(label).attr('title', trimmedLabel).attr('alt', trimmedLabel);

        // Remove any previous entry for this filter type and add the new one
        this._activeFilters = this._activeFilters.filter(f => f[0] !== filter);
        this._activeFilters.push([filter, value]);
        this._currentPage = 1;

        // Update URL bar with current params
        this._addParamsToUrl();

        // Hide cards, then load new cards after animation
        this._hideCards(() => {
            this._showPreloader('show'); //show preloader
            this.loadCards(data => {
                this._$grid.empty();
                this._cleanResponseObject(data);
                this.displayCards(data);
            });
        });
    },

    // Helper to extract grid params as [key, value] pairs
    _getGridParams: function(paramList) {
        const params = [];
        paramList.forEach(param => {
            const value = this._$grid.attr('data-' + param);
            if (value) params.push([param, value]);
        });
        return params;
    },

    // Load cards function, this has the endpoints url
    loadCards: function (cb) {
        // Endpoint and param definitions
        const endpointsList = {
            blog: 'rithum/v1/blog-api',
            resources: 'rithum/v1/resources-api',
            case_study: 'rithum/v1/case-studies-api',
            event: 'rithum/v1/events-api',
            press: 'rithum/v1/press-api',
            partners: 'rithum/v1/partners-api',
            archive: 'rithum/v1/archive-api',
            product_updates: 'rithum/v1/product-updates-api',
        };

        const extraFields = {
            blog: ['excluded'],
            resources: ['excluded'],
            case_study: ['excluded'],
            event: ['excluded'],
            press: [],
            partners: [],
            archive: [],
            product_updates: [],
        };

        const extraParams = {
            partners: ['partner_category', 'channel', 'country', 'region'],
            resources: ['topic', 'asset_type'],
            case_study: ['industry', 'client_type', 'product'],
            event: ['topic', 'region', 'audience'],
            case_study: ['industry', 'client_type', 'product', 'region'],
            archive: ['query-vars'],
        };

        // Build endpoint URL
        let endpointUrl = '/wp-json/' + endpointsList[this._dataSection];

        // Add extra fields to the endpoint URL
        const extras = (extraFields[this._dataSection] || [])
            .map(field => this._$grid.attr('data-' + field))
            .filter(Boolean);
        if (extras.length) endpointUrl += '/' + extras.join('/');

        endpointUrl += '/' + this._currentPage;

        // Combine extra params and active filters for query string
        const paramList = extraParams[this._dataSection] || [];
        const gridParams = this._getGridParams(paramList);
        const allFilters = [...gridParams, ...this._activeFilters];
        if (allFilters.length) {
            endpointUrl += '?' + this._extractExtras(allFilters);
        }

        // AJAX call to get data from the endpoint
        return $.ajax({ url: endpointUrl }).done(cb);
    },

    // Helper function to extract url params from array
    _extractExtras: function(arr) {
        // Converts [['key', 'value'], ...] to 'key=value&...'
        return arr.map(f => `${f[0]}=${encodeURIComponent(f[1])}`).join('&');
    },

    // Remove optional card fields when the response has no meaningful value
    _removeIfEmpty: function ($elem, value) {
        if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) {
            $elem.remove();
            return true;
        }

        return false;
    },

    // Feed the card with helper function
    _feedCard: function (card, data) {
        // Set card type class — remove stale type from clone before applying new one
        if (data.type !== undefined) {
            const prevType = card.data('cardType') || '';
            card.removeClass('disabled enabled ' + prevType).addClass(data.type);
            card.attr('data-card-type', data.type);
        }
        // Fill card fields
        const $elem = card.find('[class*="rt-js-card__"]');
        for (let i = 0; i < $elem.length; i++) {
            const $currentElem = $($elem[i]);
            const dataKeyMatch = $currentElem.attr('class').match(/rt-js-card__([a-zA-Z0-9_-]+)/);
            if (!dataKeyMatch) continue;
            const dataKey = dataKeyMatch[1];
            const value = data[dataKey];
            if (this._removeIfEmpty($currentElem, value)) continue;

            if (value !== undefined) {
                if (dataKey === 'image') {
                    $currentElem.html(value);
                } else if (dataKey === 'link') {
                    $currentElem.attr('href', value).attr('target', data.target);
                } else {
                    $currentElem.html(value);
                }
            }
        }
    },

    // Clean up response object and update pagination variables
    _cleanResponseObject: function (data) {
        this._totalItems = data.total_posts;
        this._currentPage = data.current_page;
        this._totalPages = data.total_pages;
        this._currentPost = data.current_post_index;
        delete data.total_pages;
        delete data.current_page;
        delete data.total_posts;
        delete data.current_post_index;
    },

    // Hide cards helper function (with animation)
    _hideCards: function (callback) {
        const $cards = this._$grid.find('.rt-js-card');
        let called = false;
        // Hide all cards at once
        $cards.addClass('rt-card--hidden');
        if ($cards.length) {
            // Wait for the last card's transition to end, then callback
            $cards.last().one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
                if (!called) {
                    called = true;
                    if (typeof callback === 'function') callback();
                }
            });
        } else {
            // If no cards, call callback immediately
            if (typeof callback === 'function') callback();
        }
    },

    // Update the pagination counter
    _updateCounter() {
        const cardCount = this._$grid.find('.rt-js-card').length;
        const totalCount = this._totalItems;
        this._$paginationElem.find('.rt-js-current-number').text(cardCount);
        this._$paginationElem.find('.rt-js-total-number').text(totalCount);
        this._currentPost = cardCount;
        this._totalItems = totalCount;
    },

    // Show/hide menu helper function
    _showHideMenu: function ($elem, action) {
        const $filterElem = $($elem).closest('.rt-js-filter');
        const isOpenClass = 'is-open';

        if (action === 'show') {
            // Close all other menus
            this._$filterElem.not($filterElem).removeClass(isOpenClass);
            // Toggle this menu
            $filterElem.toggleClass(isOpenClass);
        } else if (action === 'hide') {
            // Add a small timeout before hiding for UX
            setTimeout(() => {
                $filterElem.removeClass(isOpenClass);
            }, 200);
        }
    },

    // Helper function to add params to URL bar when filters are clicked
    _addParamsToUrl: function() {
        const url = new URL(window.location);
        this._activeFilters.forEach(filter => {
            url.searchParams.set(filter[0], filter[1]);
        });
        window.history.replaceState({}, '', url);   
    },

    // Create preloader element
    _createPreloader: function() {
        // Create preloader HTML and append to grid's parent
        const preloaderHtml = `
            <div class="rt-preloader rt-js-preloader">
                <div class="rt-preloader__spinner"></div>
            </div>`;
        this._$grid.parent().append(preloaderHtml);
        this._showPreloader('hide'); // Hide initially
    },

    // Show preloader function
    _showPreloader: function(action = 'show') {
        // Select the preloader element
        $preloader = this._$grid.parent().find('.rt-js-preloader');

        // Show or hide based on action
        if(action === 'show') {
            $preloader.show();
        } else if(action === 'hide') {
            $preloader.hide();
        }
    }
}